import { Stack } from 'src/core/ui';
import { Button } from 'src/core/ui/Button';
import { AggregateMetricsTimePeriod } from 'src/WebApiController';

import { DashboardSectionWrapper } from '../DashboardSectionWrapper';
import * as styles from './DataInsightsChart.css';
import { useDataInsights } from './DataInsightsContext';

export type TimePeriod = '24hrs' | '7d' | '30d' | '1yr' | 'all';

export const TimePeriodSelector = () => {
  const { timePeriod, setTimePeriod } = useDataInsights();
  const TIME_PERIOD_OPTIONS: {
    value: AggregateMetricsTimePeriod;
    label: string;
  }[] = [
    { value: AggregateMetricsTimePeriod.Today, label: 'Today' },
    { value: AggregateMetricsTimePeriod.LastWeek, label: '1 Wk' },
    { value: AggregateMetricsTimePeriod.LastMonth, label: '1 Mo' },
    { value: AggregateMetricsTimePeriod.LastThreeMonths, label: '3 Mo' },
    { value: AggregateMetricsTimePeriod.Ytd, label: 'YTD' },
    { value: AggregateMetricsTimePeriod.LastYear, label: '1 Yr' },
    { value: AggregateMetricsTimePeriod.LastFiveYears, label: '5 Yr' },
    { value: AggregateMetricsTimePeriod.All, label: 'All' },
  ];

  return (
    <DashboardSectionWrapper fixed>
      <Stack className={styles.timePeriodSelector}>
        {TIME_PERIOD_OPTIONS.map((option) => (
          <Button
            shape="rect"
            size="md"
            key={option.value}
            variant={timePeriod === option.value ? 'rectangle' : 'textPlain'}
            className={styles.timePeriodSelectorButton}
            onClick={() => setTimePeriod?.(option.value)}
          >
            {option.label}
          </Button>
        ))}
      </Stack>
    </DashboardSectionWrapper>
  );
};
